import lazy from 'react-lazy-with-preload';
import {
   LOYALTY_LINKING_LANDING_PATHNAME, 
   LOYALTY_LINKING_LOGIN_PATHNAME, 
   LOYALTY_LINKING_FORGOT_PASSWORD_PATHNAME, 
   LOYALTY_LINKING_OTP_PATHNAME,
   LOYALTY_LINKING_REGISTER_PATHNAME, 
} from '../../shared/pathnames';

export const loyaltyLinkingRoutes = [
    {
        path: LOYALTY_LINKING_LANDING_PATHNAME,
        name: 'LoyaltyLinkingLandingPage',
        component: lazy(() => import('../../features/loyaltyLinking/landing/Landing')),
      },
      {
        path: LOYALTY_LINKING_LOGIN_PATHNAME,
        name: 'LoyaltyLinkingLoginPage',
        component: lazy(() => import('../../features/loyaltyLinking/login/Login')),
      },
      {
        path: LOYALTY_LINKING_FORGOT_PASSWORD_PATHNAME,
        name: 'LoyaltyLinkingForgotPasswordPage',
        component: lazy(() => import('../../features/loyaltyLinking/forgot-password/ForgotPassword')),
      },
      {
        path: LOYALTY_LINKING_OTP_PATHNAME,
        name: 'LoyaltyLinkingOtp',
        component: lazy(() => import('../../features/loyaltyLinking/otp/Otp')),
      },
      {
        path: LOYALTY_LINKING_REGISTER_PATHNAME,
        name: 'LoyaltyLinkingRegister',
        component: lazy(() => import('../../features/loyaltyLinking/register/Register')),
      }
    ]